import {
  BuildResult,
  ContractPreviewResult,
} from 'src/lib/mock-utils/resolvers/types/codegenTypes';

export interface SchemaDiffMetaData {
  apiSchema: string;
  supergraphSchema: string;
  typeCount: number;
  fieldCount: number;
}

export function formatSchemaDiffMetaData(
  result: BuildResult | ContractPreviewResult | undefined,
): SchemaDiffMetaData | undefined {
  switch (result?.__typename) {
    case 'BuildSuccess': {
      return {
        apiSchema: result.coreSchema.apiDocument,
        supergraphSchema: result.coreSchema.coreDocument,
        typeCount: result.coreSchema.typeCount,
        fieldCount: result.coreSchema.fieldCount,
      };
    }

    case 'ContractPreviewSuccess': {
      return {
        apiSchema: result.apiDocument,
        supergraphSchema: result.coreDocument,
        typeCount: result.typeCount,
        fieldCount: result.fieldCount,
      };
    }

    default:
      return undefined;
  }
}
